






















































import Vue from "vue";
export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false
    },
    identifier: {
      type: String,
      required: true
    },
    mobileBottom: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    extraSmall: {
      type: Boolean
    },
    dialog: {
      type: Boolean,
      default: false
    },
    modalClass: {
      type: String
    }
  },
  data() {
    return {
      scroll: {
        margin: document.body.getBoundingClientRect().top,
        top: null
      }
    };
  },
  methods: {
    close(e: Event) {
      if (e.target === this.$refs["modal-wrapper"]) {
        this.$emit("close");
      }
    },
    freezeVp(e) {
      e.preventDefault();
    },
    stopBodyScrolling(bool) {
      if (bool === true) {
        document.body.addEventListener("touchmove", this.freezeVp, false);
      } else {
        document.body.removeEventListener("touchmove", this.freezeVp, false);
      }
    }
  },
  watch: {
    show(newVal, oldVal) {
      const modal = this.$refs.modal as HTMLLIElement;
      const modalParent = this.$refs["modal-parent"] as HTMLLIElement;

      if (newVal) {
        document.body.append(modal);
        this.stopBodyScrolling(true);
        document.documentElement.dataset["modalActive"] = "true";
      } else {
        modalParent.append(modal);
        document.documentElement.dataset["modalActive"] = "false";
        this.stopBodyScrolling(false);
      }
    }
  },
  mounted() {
    if (this.show) {
      document.body.append(this.$refs.modal as HTMLElement);
      document.documentElement.dataset["modalActive"] = "true";
      this.stopBodyScrolling(true);
    }
  }
});
